import React from 'react';
import * as styles from './styles.module.css';

export function Separator() {
  return <div className={styles.separator} />;
}
